











































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import Session from '@/app/module/session'
/* api */
import GetImageApi from '@/app/model/api/getImageApi'

@Component
export default class DetailsImg extends Vue {
  private showImgModal: boolean = false;
  private imagePath: string = ''
  private originalImagePath: string = ''
  private keyDay: string = ''
  private displayImg: string = ''
  private imgArrow: any[] = []
  private imgLoadingFlag: boolean = false

  @Prop() private plantingId!: number
  @Prop() private imgPath!: string
  @Prop() private keyDate!: string

  /* 日にちの変更を監視 */
  private get changeDate (): string {
    return this.keyDate
  }
  @Watch('changeDate')
  onDateChoice (newValue: string) {
    /* 配列が空かつ画像読み込み中でなければAPIリクエスト */
    if (this.imgArrow.length === 0 && this.imgLoadingFlag === false) {
      this.imgArrow.push(String(newValue))
      setTimeout(this.getNewImage, 100)
    } else {
    /* 配列が空ではないまたは画像読み込み中であれば配列に追加のみ */
      this.imgArrow.push(String(newValue))
    }
  }

  /* 圃場詳細画面で日付を変更したい際に発火(サムネイル画像) */
  private async getNewImage () {
    this.imgLoadingFlag = true
    /* 画像の配列が空になるまで、画像を配列の後ろから取得 */
    while (this.imgArrow.length !== 0) {
      let newDate = this.imgArrow.pop()
      if (this.imgPath !== '/img/ico_barley_02.37101e46.svg' && this.imgPath !== '' && this.imgPath !== undefined) {
        let type = ''
        let id = Session.getPlantingId()!
        let body: any = {
          type: type,
          planting_id: id,
          date: newDate
        }

        const result = await GetImageApi.getImageData(body)
        if (String(this.keyDate) === newDate) {
          this.displayImg = String(result)
        }
      } else {
        this.displayImg = require('@/assets/icon/ico_barley_02.svg')
      }
    }
    this.imgLoadingFlag = false
  }

  /* モーダルのオリジナル画像を取得 */
  private async showModal () {
    /* original画像取得 */
    if (this.imgPath !== '/img/ico_barley_02.37101e46.svg' && this.imgPath !== '' && this.imgPath !== undefined) {
      let id = Session.getPlantingId()!
      if (id !== '0') {
        let type = 'original'
        let body: any = {
          planting_id: id,
          date: this.keyDate,
          type: type
        }

        const result = await GetImageApi.getImageData(body)
        this.originalImagePath = String(result)
      } else {
        this.originalImagePath = require('@/assets/icon/ico_barley_02.svg')
      }
    } else {
      this.originalImagePath = require('@/assets/icon/ico_barley_02.svg')
    }

    this.showImgModal = true
  }
}
